import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import AvailabilityEditor from "@/components/portal/AvailabilityEditor";
import SlotsPreview from "@/components/portal/SlotsPreview";
import { PageHeader } from "@/components/portal/ui";

export default function DoctorCalendar() {
  const { user } = useAuth();
  const [refreshKey, setRefreshKey] = useState(0);
  const pending = user.status !== "approved";

  return (
    <div data-testid="doctor-calendar">
      <PageHeader eyebrow="Il mio calendario" title={`Buongiorno, ${user.first_name}`} desc="Imposta i giorni e le fasce orarie in cui sei disponibile per le visite assistite. Puoi modificarle in qualsiasi momento: le disponibilità comunicate ai pazienti si aggiornano subito." />
      {pending && (
        <p className="mb-6 rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-800 ring-1 ring-amber-200" data-testid="doctor-pending-banner">
          Il tuo profilo è in valutazione dal team TytoCare. Puoi già impostare gli orari: verranno pubblicati appena l'account sarà approvato.
        </p>
      )}
      <div className="flex flex-col gap-6">
        <AvailabilityEditor endpoint="/availability/me" onSaved={() => setRefreshKey((k) => k + 1)} />
        <SlotsPreview doctorId={user.id} refreshKey={refreshKey} title="I tuoi slot liberi" note={pending ? "Gli slot saranno visibili ai pazienti dopo l'approvazione del profilo." : "Questi orari vengono comunicati automaticamente a chi chiede informazioni su WhatsApp, al netto delle visite già prenotate."} />
      </div>
    </div>
  );
}
